import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useAuth } from './features/auth/AuthContext';

import { BuchhaltungLayout } from './components/layout/BuchhaltungLayout';
import { LoginPage } from './features/auth/LoginPage';
import { AuthCallbackPage } from './features/auth/AuthCallbackPage';
import { EingangPage } from './features/eingang/EingangPage';
import { BelegPage } from './features/eingang/BelegPage';
import { ZuZahlenPage } from './features/zu-zahlen/ZuZahlenPage';
import { PrueflistePage } from './features/pruefliste/PrueflistePage';
import { BankPage } from './features/bank/BankPage';
import { ScanPage } from './features/scan/ScanPage';
import { ReviewPage } from './features/review/ReviewPage';
import { LieferantenPage } from './features/lieferanten/LieferantenPage';
import { EinstellungenPage } from './features/einstellungen/EinstellungenPage';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-12 w-12 animate-spin rounded-full border-4 border-primary-600 border-t-transparent"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Ziel merken. Wichtig fuer /scan: wer den Knopf auf dem Startbildschirm
    // antippt und nicht angemeldet ist, soll nach der Anmeldung auf der
    // Kamera landen und nicht auf dem Eingang.
    const ziel = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?ziel=${ziel}`} replace />;
  }

  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />

      <Route
        element={
          <ProtectedRoute>
            <BuchhaltungLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<Navigate to="/eingang" replace />} />
        <Route path="/eingang" element={<EingangPage />} />
        {/* Der Beleg hat eine eigene Adresse, keine Schublade neben der Liste:
            so laesst er sich verlinken — in einer Benachrichtigung, in einer
            Mail an die Kanzlei, im Log. */}
        <Route path="/eingang/:id" element={<BelegPage />} />
        <Route path="/zu-zahlen" element={<ZuZahlenPage />} />
        <Route path="/pruefliste" element={<PrueflistePage />} />
        <Route path="/bank" element={<BankPage />} />
        <Route path="/scan" element={<ScanPage />} />
        <Route path="/review" element={<ReviewPage />} />
        <Route path="/lieferanten" element={<LieferantenPage />} />
        <Route path="/einstellungen" element={<EinstellungenPage />} />
      </Route>

      {/* Was sonst niemand kennt, gehoert auf den Eingang. */}
      <Route path="*" element={<Navigate to="/eingang" replace />} />
    </Routes>
  );
}
